import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function AvailabilitiesPeriodsIcon({ className }: IconProps) {
  return (
    <svg
      width="82"
      height="82"
      viewBox="0 0 82 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1206_99)">
        <path
          d="M8.1084 36.9584C8.1084 57.3776 24.6477 73.9169 45.0668 73.9169C65.486 73.9169 82.0004 57.3776 82.0004 36.9584C82.0004 16.5393 65.4611 0 45.0668 0C24.6726 0 8.1084 16.5393 8.1084 36.9584Z"
          fill="#EAF0F3"
        />
        <path
          d="M11.3662 36.9586C11.3662 55.5622 26.463 70.659 45.0665 70.659C63.6701 70.659 78.7669 55.5622 78.7669 36.9586C78.7669 18.3551 63.6701 3.2583 45.0665 3.2583C26.463 3.2583 11.3662 18.3302 11.3662 36.9586Z"
          fill="#00C4B3"
        />
        <path
          d="M15.5947 36.9586C15.5947 38.0031 16.4403 38.8488 17.4849 38.8488C18.5295 38.8488 19.3751 38.0031 19.3751 36.9586C19.3751 35.914 18.5295 35.0684 17.4849 35.0684C16.4403 35.0684 15.5947 35.914 15.5947 36.9586Z"
          fill="white"
        />
        <path
          d="M70.7334 36.9586C70.7334 38.0031 71.579 38.8488 72.6236 38.8488C73.6682 38.8488 74.5138 38.0031 74.5138 36.9586C74.5138 35.914 73.6682 35.0684 72.6236 35.0684C71.579 35.0684 70.7334 35.914 70.7334 36.9586Z"
          fill="white"
        />
        <path
          d="M19.5491 51.682C20.0713 52.6023 21.2403 52.9007 22.1356 52.3784C23.0559 51.8561 23.3543 50.6872 22.832 49.7918C22.3097 48.8716 21.1408 48.5731 20.2454 49.0954C19.3252 49.6177 19.0268 50.7867 19.5491 51.682Z"
          fill="white"
        />
        <path
          d="M67.2766 24.1249C67.7989 25.0451 68.9678 25.3436 69.8632 24.8213C70.7834 24.299 71.0819 23.1301 70.5596 22.2347C70.0373 21.3145 68.8683 21.016 67.973 21.5383C67.0528 22.0606 66.7543 23.2295 67.2766 24.1249Z"
          fill="white"
        />
        <path
          d="M30.3187 62.4761C31.2389 62.9984 32.383 62.6999 32.9053 61.7797C33.4276 60.8595 33.1291 59.7154 32.2089 59.1931C31.2887 58.6708 30.1446 58.9693 29.6223 59.8895C29.1 60.8097 29.3985 61.9538 30.3187 62.4761Z"
          fill="white"
        />
        <path
          d="M57.9002 14.7236C58.8204 15.2459 59.9645 14.9475 60.4868 14.0273C61.0091 13.107 60.7106 11.963 59.7904 11.4407C58.895 10.9184 57.7261 11.2168 57.2038 12.137C56.6815 13.0573 57.0048 14.2013 57.9002 14.7236Z"
          fill="white"
        />
        <path
          d="M59.7909 62.4761C60.7112 61.9538 61.0096 60.7849 60.4873 59.8895C59.965 58.9693 58.7961 58.6708 57.9007 59.1931C56.9805 59.7154 56.682 60.8843 57.2043 61.7797C57.7266 62.6999 58.8956 62.9984 59.7909 62.4761Z"
          fill="white"
        />
        <path
          d="M32.2333 14.7236C33.1535 14.2013 33.452 13.0324 32.9297 12.137C32.4074 11.2168 31.2385 10.9184 30.3431 11.4407C29.4229 11.963 29.1244 13.1319 29.6467 14.0273C30.169 14.9475 31.3379 15.2459 32.2333 14.7236Z"
          fill="white"
        />
        <path
          d="M70.5844 51.682C71.1067 50.7618 70.8083 49.6177 69.8881 49.0954C68.9678 48.5731 67.8237 48.8716 67.3015 49.7918C66.7792 50.7121 67.1025 51.8561 67.9978 52.3784C68.9181 52.9007 70.0621 52.6023 70.5844 51.682Z"
          fill="white"
        />
        <path
          d="M22.8325 24.1249C23.3548 23.2047 23.0563 22.0606 22.1361 21.5383C21.2159 21.016 20.0718 21.3145 19.5495 22.2347C19.0272 23.1549 19.3505 24.299 20.2459 24.8213C21.1661 25.3436 22.3102 25.0451 22.8325 24.1249Z"
          fill="white"
        />
        <path
          d="M45.0664 66.4308C46.111 66.4308 46.9566 65.5852 46.9566 64.5406C46.9566 63.496 46.111 62.6504 45.0664 62.6504C44.0219 62.6504 43.1514 63.496 43.1514 64.5406C43.1514 65.5852 43.997 66.4308 45.0664 66.4308Z"
          fill="white"
        />
        <path
          d="M63.1236 38.6498H45.0672C44.147 38.6498 43.376 37.9037 43.376 36.9586V9.94856C43.376 9.02833 44.1221 8.25732 45.0672 8.25732C46.0123 8.25732 46.7584 9.00346 46.7584 9.94856V35.2673H63.1236C64.0439 35.2673 64.8149 36.0135 64.8149 36.9586C64.8149 37.9037 64.0687 38.6498 63.1236 38.6498Z"
          fill="#00416B"
        />
        <path
          d="M39.9932 36.9585C39.9932 39.7441 42.2564 42.0073 45.042 42.0073C47.8276 42.0073 50.0908 39.7441 50.0908 36.9585C50.0908 34.1729 47.8276 31.9097 45.042 31.9097C42.2564 31.9097 39.9932 34.1729 39.9932 36.9585Z"
          fill="#FBFCFE"
        />
        <path
          d="M0 45.4395C1.64149 64.8639 17.1362 80.3586 36.5605 82C38.401 82.1493 39.9927 80.6819 39.9927 78.8414V45.166C39.9927 43.425 38.5751 42.0073 36.8341 42.0073H3.1835C1.34304 42.0073 -0.124355 43.5991 0.0248711 45.4395H0Z"
          fill="#203E6A"
        />
        <path
          d="M22.4338 60.3868C22.4338 63.0729 20.668 65.3859 17.6834 65.2615C15.0471 65.162 12.4605 62.7247 13.132 57.1784C13.7041 52.1047 16.415 50.3389 18.6534 50.3389C20.6182 50.3389 21.6877 51.5824 21.9613 51.8809L20.4441 53.3234C20.2203 53.0747 19.4493 52.7016 18.5291 52.7265C17.0368 52.8011 15.9673 54.5172 15.7186 57.2033C16.0917 56.88 17.1114 56.0095 18.5539 56.0095C20.5685 56.0095 22.4338 57.5515 22.4338 60.3868ZM19.8223 60.4365C19.8223 59.2925 19.2254 58.3225 17.8575 58.3971C16.7383 58.4468 15.9922 59.1184 15.7186 59.5909C15.644 60.8096 16.1912 62.5754 17.6337 62.6998C19.126 62.8242 19.8223 61.6801 19.8223 60.4365Z"
          fill="#FBFCFE"
        />
        <path
          d="M32.4073 59.6159V65.0875H29.6217V59.4915C29.6217 58.0241 29 57.4272 27.9802 57.4272C26.9605 57.4272 26.3139 58.0987 26.3139 59.591V65.0626H23.5283V50.4136H26.3139V55.8603C26.9108 55.2386 27.7067 54.8406 28.6518 54.8406C30.9648 54.8406 32.4073 56.4821 32.4073 59.591V59.6159Z"
          fill="#FBFCFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_1206_99">
          <rect width="82" height="82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
